<template>
  <router-view></router-view>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  setup() {
    const store = useStore()
    const data = reactive({
      show: true,
    })
    setInterval(() => {
      store.dispatch('countUp')
    }, 1000)
    return { ...toRefs(data) }
  },
})
</script>

<style scoped></style>
